import AWS from 'aws-sdk'
import initAWSTemporaryCredentials from './InitAWS.ts';

const uploadToS3 = async (fileData: string | Blob | File | FormData) => {
  try {
    AWS.config.update({ region: 'ap-southeast-2' });
    const credentials = await initAWSTemporaryCredentials();
    AWS.config.credentials = credentials;

    const s3 = new AWS.S3();

    let arrayBuffer: ArrayBuffer;
    let contentType: string;
    let fileExtension: string;
    let fileName: string;
    let params;

    // Handle Blob URLs (from URL.createObjectURL)
    if (typeof fileData === 'string' && fileData.startsWith('blob:')) {
      try {
        const response = await fetch(fileData);
        const blob = await response.blob();
        fileData = blob;
      } catch (error) {
        console.error('Error converting blob URL to blob:', error);
        throw new Error('Failed to process blob URL');
      }
    }

    if (typeof fileData === 'string') {
      // Handle base64 image
      const base64Data = fileData.replace(/^data:image\/\w+;base64,/, '');
      const binaryData = atob(base64Data);
      arrayBuffer = new Uint8Array(binaryData.length);
      for (let i = 0; i < binaryData.length; i++) {
        arrayBuffer[i] = binaryData.charCodeAt(i);
      }
      contentType = 'image/jpeg';
      fileExtension = 'jpeg';
      fileName = `image-${Date.now()}.${fileExtension}`;

      params = {
        Bucket: 'timecapsule-all-images',
        Key: `photos/photo-${Date.now()}.jpeg`,
        Body: arrayBuffer,
        ContentType: contentType,
      };
    } else if (fileData instanceof Blob || fileData instanceof File) {
      // Handle Blob or File
      arrayBuffer = await fileData.arrayBuffer();
      contentType = fileData.type || 'image/jpeg'; // Default to jpeg if type is missing
      
      // Handle HEIC/HEIF images from iPhones
      if (contentType.includes('heic') || contentType.includes('heif') || 
          (fileData instanceof File && 
           (fileData.name.toLowerCase().endsWith('.heic') || fileData.name.toLowerCase().endsWith('.heif')))) {
        contentType = 'image/jpeg';
        fileExtension = 'jpeg';
      } else {
        fileExtension = contentType.split('/')[1] || 'jpeg';
      }
      
      const isVideo = contentType.startsWith('video');
      const filePrefix = isVideo ? 'video' : 'photo';
      const fileType = isVideo ? '.mp4' : `.${fileExtension}`;
      
      params = {
        Bucket: 'timecapsule-all-images',
        Key: `photos/${filePrefix}-${Date.now()}${fileType}`,
        Body: arrayBuffer,
        ContentType: contentType,
      };
    } else if (fileData instanceof FormData) {
      // Handle FormData
      const file = fileData.get('file') as File;
      if (!file) throw new Error('No file found in FormData');
      arrayBuffer = await file.arrayBuffer();
      contentType = file.type || 'image/jpeg';
      
      // Handle HEIC/HEIF images from iPhones
      if (contentType.includes('heic') || contentType.includes('heif') || 
          file.name.toLowerCase().endsWith('.heic') || file.name.toLowerCase().endsWith('.heif')) {
        contentType = 'image/jpeg';
        fileExtension = 'jpeg';
      } else {
        fileExtension = contentType.split('/')[1] || 'jpeg';
      }
      
      const isVideo = contentType.startsWith('video');
      const filePrefix = isVideo ? 'video' : 'photo';
      const fileType = isVideo ? '.mp4' : `.${fileExtension}`;
      
      params = {
        Bucket: 'timecapsule-all-images',
        Key: `photos/${filePrefix}-${Date.now()}${fileType}`,
        Body: arrayBuffer,
        ContentType: contentType,
      };
    } else {
      throw new Error('Invalid file data');
    }
  
    const data = await s3.upload(params).promise();
    console.log('Image uploaded successfully:', data.Location);
    return data.Location;
  } catch (error) {
    console.error('Error uploading image:', error);
    // Don't show alert here, let the calling component handle errors
    throw error;
  }
};

export default uploadToS3;
